export default function multihirer(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                multihirer: action.multihirer,
            }
        default:
            return state;
    }
}
